<template>
  <div>
    <!-- Modal Popup -->
    <div v-if="showPopup" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50">
      <div class="bg-white md:p-20 py-14 px-5 shadow-lg text-center md:w-3/5 w-full mx-5 popup-container">
        <h2 class="text-2xl font-semibold mb-4">
          {{ $trans.get("registration.popup.title") }}
        </h2>
        <p class="text-blue mb-6">
          {{ $trans.get("registration.popup.subtitle") }}
        </p>
        <p class="mb-6">{{ $trans.get("registration.popup.description") }}</p>
        <a class="btn border-2 border-blue text-blue cursor-pointer" @click="closePopup">
            {{ $trans.get("registration.popup.start") }}
        </a>
      </div>
    </div>

    <!-- Formulario principal -->
    <div class="flex flex-col">
      <div class="container">
        <h3 class="mb-2 w-full text-center mt-8 text-xl font-bold">
          {{ $trans.get("registration.title") }}
        </h3>
        <p class="text-blue text-center mb-6 text-sm">{{ $trans.get("registration.popup.subtitle") }}</p>
        <!-- Tabs de navegación -->
        <div class="flex justify-center items-center gap-5 mb-10">
          <button
            v-for="(step, index) in steps"
            :key="index"
            @click="currentStep = index + 1"
            class="w-full p-4 text-center font-semibold border text-xs lg:text-sm hover:bg-blue-dark hover:text-white"
            :class="{
              'bg-blue-dark text-white': currentStep === index + 1,
              'text-black': currentStep !== index + 1
            }"
          >
            {{ stepLabels[index] }}
          </button>
        </div>
      </div>
      <form class="bg-wizard pt-8 lg:pb-24 xl:pb-32 2xl:pb-48">
        <div class="container">
          <personal-data v-show="currentStep == 1" :personal="registration.personal" :address="registration.address" @update-age="userAge = $event" :blanks="blanks">
          </personal-data>
          <address-data v-show="currentStep == 2" :address="registration.address">
          </address-data>
          <academic-data v-show="currentStep == 3" :academic="registration.academic" :courses="courses" :courseRegistrationId="registration.course_id"></academic-data>
          <general-data v-show="currentStep == 4" :general="registration.general" :userAge="userAge"></general-data>

          <div class="flex justify-center gap-10 my-10">
              <button v-if="currentStep > 1" @click="goBack()" type="button" class="flex items-center text-blue hover:text-blue-darkest underline font-medium">
                <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="currentColor" class="mr-1">
                  <path d="M0 0h24v24H0V0z" fill="none"/>
                  <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z"/>
                </svg>
                {{ $trans.get("registration.back") }}
              </button>
            <button
              v-if="currentStep < 4"
              class="flex items-center text-blue hover:text-blue-darkest underline font-medium"
              @click="saveData()"
              type="button"
            >
            <span>{{ $trans.get("registration.next") }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="currentColor" class="ml-1">
                <path d="M0 0h24v24H0V0z" fill="none"/>
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/>
              </svg>
            </button>
            <button
              v-if="currentStep == 4"
              class="btn bg-blue-dark text-white px-4 py-2 rounded hover:bg-blue-darker transition duration-300"
              @click="saveData(true)"
              type="button"
            >
              Enviar
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>



<script>
import PersonalData from "./PersonalData.vue";
import AddressData from "./AddressData.vue";
import AcademicData from "./AcademicData.vue";
import GeneralData from "./GeneralData.vue";
import axios from "axios";

export default {
  props: {
    registration: {
      type: Object,
      required: false,
    },
    courses: {
      type: Array,
      required: true,
    },

  },
  data: () => {
    return {
      loading: false,
      files: '',
      showPopup: true,
      currentStep: 1,
      showTutorsSection: false,
      blanks: 0,
      steps: [
        "registration.personal-title",
        "registration.address-title-btn",
        "registration.academic-title-btn",
        "registration.general-title-btn"
      ],    };
  },
  components: {
    PersonalData,
    AddressData,
    AcademicData,
    GeneralData
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 640;
    },
    stepLabels() {
      if (this.isMobile) {
        return [
          this.$trans.get("registration.step1"),
          this.$trans.get("registration.step2"),
          this.$trans.get("registration.step3"),
          this.$trans.get("registration.step4")
        ];
      } else {
        return this.steps.map(step => this.$trans.get(step));
      }
    },
  },
  methods: {
    goBack() {
      if (this.currentStep > 1) {
        this.currentStep--;
      }
    },
    closePopup() {
      this.showPopup = false;
    },
    handlePersonalBasic({ value, name }) {
      this.form.personal.basic[name].value = value;
    },
    handlePersonal({ value, name }) {
      this.form.personal[name].value = value;
    },
    handleAddress({ value, name }) {
      this.form.address[name].value = value;
    },
    handlePersonalExtra({ value, name }) {
      this.form.personal.extra[name].value = value;
    },
    saveData(send = false) {
      let fields = document.getElementsByTagName('form');
      this.blanks = 0;
      if (send) {
        for (let n = 0; n < fields[0].length; n++) {
          let el = fields[0][n];

          if (el.required && el.type !== 'checkbox' && el.value.trim().length === 0) {
            el.classList.add("border-red-500");
            this.blanks++;
          } else if (el.required && el.type === 'checkbox' && !el.checked) {
            el.classList.add("border-red-500");
            this.blanks++;
          } else if (el.required && el.tagName === "SELECT" && (el.value.trim() === "" || el.value === "Selecciona")) {
            el.classList.add("border-red-500");
            this.blanks++;
          }
          else if (el.required && el.tagName === "SELECT" && (el.value.trim() === "" || el.value === "Selecciona")) {
            el.classList.add("border-red-500");
            this.blanks++;
          }   else {
            el.classList.remove("border-red-500");
          }
          if(el.name === 'photoCardFile'){

            const label = document.querySelector(`label[for="photoCardFile"]`);

            if(this.registration.personal.photoCardFile == "0" && !el.value ) {
                if (label) label.classList.add("border-red-500");
                this.blanks++;
            }else{
                if(label) label.classList.remove("border-red-500");
            }
          }

          if(el.name === 'idFiles'){
              console.log("required", el.required);
              console.log("name", el.name);
              console.log("type", el.type);
              console.log("value", el.value);
              console.log("idFiles", this.registration.personal.idFiles);

            const label = document.querySelector(`label[for="idFiles"]`);

            if((this.registration.personal.idFilesB == "0" && this.registration.personal.idFilesF == "0") && !el.value ) {
                if (label) label.classList.add("border-red-500");
                this.blanks++;
            }else{
                if(label) label.classList.remove("border-red-500");
            }
          }

        }
        // if (!this.registration.personal.idFiles || this.registration.personal.idFiles.value.length === 0) {
        //   let label = document.querySelector(`label[for="idFiles"]`);
        //   if (label) {
        //     label.classList.add("border-red-500");
        //   }
        //   this.blanks++;
        // }

        // if (!this.registration.personal.idFiles || this.registration.personal.idFiles.value.length === 0) {
        //   let label = document.querySelector(`label[for="photoCardFile"]`);
        //   console.log('label', this.registration.personal.photoCardFile);

        //     if (this.registration.personal.photoCardFile == "0") {
        //         console.log("add border");
        //         label.classList.add("border-red-500");
        //     } else {
        //         console.log("remove border");
        //         label.classList.remove("border-red-500");
        //     }
        //     this.blanks++;
        // }




      }

      console.log("blanks", this.blanks);



      if(this.blanks === 0){
        this.loading = true;
        const { personal, address: addressTutors } = this.$children[0]._data.form;
        let { address } = this.$children[1]._data.form;
        address = {...address, ...addressTutors};

        const { academic } = this.$children[2]._data.form;
        const { general } = this.$children[3]._data.form;

        //Create FormData with Files
        /**
         * En cada caso miramos las key de los elementos que estan en personal/academic, en el caso de ser iguales a las que indicamos nostros añadimos al formData un nuevo registro con la key+n (n: Es la posicion del archivo en el array de ese campo) y el fichero.
         */
        let formData = new FormData();
        for(let key in personal){
            switch (key){
              case "idFiles":
                if(typeof personal[key].value !== 'undefined'){
                  for(let n=0; n<personal[key].value.length; n++){
                    let idKey = key;
                    if(n < personal[key].maxSize){
                      if(n === 0){
                        idKey = key+'F';
                      }else{
                        idKey = key+'B';
                      }
                      formData.append(idKey, personal[key].value[n]);
                    }
                  }
                }
                break;
              case "healthCardFiles":
                if(typeof personal[key].value !== 'undefined'){
                  for(let n=0; n<personal[key].value.length; n++){
                    let idKey = key;
                    if(n < personal[key].maxSize){
                      if(n === 0){
                        idKey = key+'F';
                      }else{
                        idKey = key+'B';
                      }
                      formData.append(idKey, personal[key].value[n]);
                    }
                  }
                }
                break;
              case "photoCardFile":
                if(typeof personal[key].value !== 'undefined'){
                  for(let n=0; n<personal[key].value.length; n++){
                    if(n < personal[key].maxSize){
                      formData.append(key+n, personal[key].value[n]);
                    }
                  }
                }
              break;


            }
        }
        for(let key in address){
            switch (key){
              case "tutor1DniFiles":
                if(typeof address[key].value !== 'undefined'){
                  for(let n=0; n<address[key].value.length; n++){
                    let idKey = key;
                    if(n < address[key].maxSize){
                      if(n === 0){
                        idKey = key+'F';
                      }else{
                        idKey = key+'B';
                      }
                      formData.append(idKey, address[key].value[n]);
                    }
                  }
                }
              break;
              case "tutor2DniFiles":
                if(typeof address[key].value !== 'undefined'){
                  for(let n=0; n<address[key].value.length; n++){
                    let idKey = key;
                    if(n < address[key].maxSize){
                      if(n === 0){
                        idKey = key+'F';
                      }else{
                        idKey = key+'B';
                      }
                      formData.append(idKey, address[key].value[n]);
                    }
                  }
                }
              break;
            }
        }

        for(let key in academic){
            switch (key){
              case "studyCertificateOptionalFile":
                if(typeof academic[key].value !== 'undefined'){
                  for(let n=0; n<academic[key].value.length; n++){
                    if(n < academic[key].maxSize){
                      formData.append(key+n, academic[key].value[n]);
                    }
                  }
                }
                break;
            }
        }

        for(let key in academic){
            switch (key){
              case "foreignStudiesFile":
                if(typeof academic[key].value !== 'undefined'){
                  for(let n=0; n<academic[key].value.length; n++){
                    if(n < academic[key].maxSize){
                      formData.append(key+n, academic[key].value[n]);
                    }
                  }
                }
                break;
            }
        }

        for(let key in academic){
            switch (key){
                case "previousStudyCertificateFile":
                    if(typeof academic[key].value !== 'undefined'){
                        for(let n=0; n<academic[key].value.length; n++){
                            if(n < academic[key].maxSize){
                                formData.append(key+n, academic[key].value[n]);
                            }
                        }
                    }
                break;
            }
          }


        const config = {
          headers: {
          'content-type': 'multipart/form-data',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
          }
        }

        formData.append("code", this.registration.code || false);
        formData.append("payload", JSON.stringify({
            personal: personal,
            address: address,
            academic: academic,
            general: general,
            send: send,
          }));

        axios
          .post("/api/registration/save", formData, config)
          .then((res) => {
            this.loading = false;
            this.$toast.open(this.$trans.get("registration.data-sent"));
            if (this.currentStep < 4) {
              this.currentStep++;
              this.$nextTick(() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth"
                });
              });
            }

            if (send) {
              window.location.href = "/form-confirm";
            }
          })
          .catch((err) => {
            this.loading = false;
            this.$toast.error(this.$trans.get("registration.error"));
          });
      }else{
        this.$toast.error(this.$trans.get("registration.error-required-fields"));
      }
    },
  },
};
</script>

<style lang="scss">
.loading-layout {
  position: fixed;
  width: 100%;
  height: 100vh;
  bottom: 0;
  left: 0;
  background-color: rgba($color: #000000, $alpha: 0.45);
  z-index: 2000;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .btn {
    background-color: transparent;
  }
}
.popup-container {
  max-width: 750px;
}
.form-container {
  max-width: 800px;
  width: 100%;

  .info-container {
    padding-right: 5%;
  }

  @media (max-width: 768px) {
    max-width: 100%;
    flex-direction: column;

    .info-container {
      padding-right: 0;
      margin-bottom: 1.5rem;
    }
  }

  /* &__inputs {
    max-width: 348px;
    width: 100%;
  } */
}
.floating-button {
  max-width: 230px;
  position: fixed;
  right: 8%;
  top: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  @media (max-width: 992px) {
    display: none;
  }
  p {
    font-size: 12px;
    text-align: center;
    color: #e96639;
    padding-bottom: 1rem;
  }
}

.expand-transition {
  transition: all 0.5s ease;
}
/* .expand-enter defines the starting state for entering */
/* .expand-leave defines the ending state for leaving */
.expand-enter,
.expand-leave {
  height: 0;
  opacity: 0;
}
</style>
